(() => {
  if (window.dsmWaitlistFormLoaded) return;
  window.dsmWaitlistFormLoaded = true;

  const url = new URL(window.location.href);

  if (url.searchParams.has('customer_posted')) {
    url.searchParams.delete('customer_posted');
    window.history.replaceState({}, '', `${url.pathname}${url.search}`);

    const scrollToWaitlist = () => {
      const waitlist = document.querySelector('.dsm-waitlist');

      if (!waitlist) return;

      const headerOffset = 150;
      const targetTop = waitlist.getBoundingClientRect().top + window.pageYOffset - headerOffset;

      window.scrollTo({ top: Math.max(targetTop, 0), left: 0 });
    };

    window.requestAnimationFrame(scrollToWaitlist);
    window.setTimeout(scrollToWaitlist, 250);
    window.addEventListener('load', () => {
      window.setTimeout(scrollToWaitlist, 150);
    }, { once: true });
  }

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-dsm-waitlist-form]');

    if (!form) return;

    const button = form.querySelector('.dsm-waitlist__button');
    const spinner = button ? button.querySelector('.loading-overlay__spinner') : null;

    if (button) {
      button.classList.add('loading');
      button.setAttribute('aria-disabled', 'true');
    }

    if (spinner) {
      spinner.classList.remove('hidden');
    }
  });
})();
